import {
  ASSET,
  SEASON,
  CLIENT,
  USER,
  SOIL,
  SUPPLIES,
  HEF_RECOMMENDATION,
  HEF_SUPPLIES,
  HEF_CLIENT,
  SOIL_JOB,
  ENVIRONMENT,
  ZON_FERTS,
} from '../constants'

export default function getRequestName (request) {
  let resolvedRequest = { name: '' }

  if (request.url.indexOf(ASSET) > -1) {
    resolvedRequest.name = 'asset'
  } else if (request.url.indexOf(SEASON) > -1) {
    resolvedRequest.name = 'season'
  } else if (request.url.indexOf(ENVIRONMENT) > -1) {
    resolvedRequest.name = 'environment'
  } else if (request.url.indexOf(SOIL_JOB) > -1) {
    resolvedRequest.name = 'jobs'
  } else if (request.url.indexOf(HEF_RECOMMENDATION) > -1) {
    resolvedRequest.name = 'recommendation'
  } else if (request.url.indexOf(ZON_FERTS) > -1) {
    resolvedRequest.name = 'fertilizer'
  } else if (request.url.indexOf(USER) > -1) {
    resolvedRequest.name = 'users'
  } else if (request.url.indexOf(SOIL) > -1) {
    resolvedRequest.name = 'soil'
  } else if ((request.url.indexOf(CLIENT) > -1) || (request.url.indexOf(HEF_CLIENT) > -1)) {
    resolvedRequest.name = 'client'
  } else if ((request.url.indexOf(SUPPLIES) > -1) || (request.url.indexOf(HEF_SUPPLIES) > -1)) {
    resolvedRequest.name = 'supplies'
  } else if (resolvedRequest.name === '') {
    resolvedRequest.name = 'unknown'
  }

  return resolvedRequest
}
